import { useFilter } from '../../filter';
import { CampaignFilterKey, CampaignFilterModel } from '../domain/campaignFilterModel';

export const useCampaignFilter = () => {
  return useFilter(
    CampaignFilterKey,
    'campaignFilter',
    (filter: any) => new CampaignFilterModel(filter),
    true
  );
};
